import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter,Link } from "react-router-dom";
import { } from "../../store/actions";


//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-sm-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";


class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div className="vertical-menu"  style={{ backgroundColor: "#AB63BF",color:"#FAF3FD" }}>
          <div className="navbar-brand-box"  style={{ backgroundColor: "#AB63BF",color:"#FAF3FD" }}>
            <Link to="/" className="logo logo-dark">
              <span className="logo-sm" >
                <img src={logo} alt="" height="22" />
              </span>
            </Link>

            <Link to="/" className="logo logo-light">
              <span className="logo-sm"  style={{ color:"white" }}>
                <img src={logoLightSvg} alt="" height="22" />
              </span>
              <span className="logo-lg"  style={{ color:"white" }}>
                <img src={logoLightPng} alt="" height="55" />
              </span>
            </Link>
          </div>
          <div data-simplebar className="h-100"  style={{ color:"white" }}>
            <SidebarContent sideBarMenuData={this.props.sideBarMenuData}/>
          </div>
          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
  sideBarMenuData : PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
